import SuperRepository from '../superRepository'

export default new (class SoloPaymentInvoicesRepository extends SuperRepository {
  baseUri() {
    return 'payment_invoice_solo'
  }
  preview = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/preview`, data, { signal })
})()
